import { render, staticRenderFns } from "./BaseModel.vue?vue&type=template&id=19c5e5a6&"
import script from "./BaseModel.vue?vue&type=script&lang=js&"
export * from "./BaseModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports